<template>
  <v-card class="pa-4 elevation-1">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <v-card-title class="text-subtitle-1 font-weight-bold pa-0">
        {{ $t('studentSatisfaction.distribution_title') }}
      </v-card-title>
      <vue-json-to-csv
        :json-data="exportRows"
        :labels="exportLabels"
        :csv-title="exportFilename"
        separator=";"
      >
        <v-btn text small color="deep-purple lighten-1" :disabled="!scoreDistribution.length">
          <v-icon left small>mdi-download</v-icon>
          {{ $t('surveys.export.button') }}
        </v-btn>
      </vue-json-to-csv>
    </div>
    <v-card-text>
      <div v-for="bucket in scoreDistribution" :key="bucket.score" class="mb-3">
        <div class="d-flex justify-space-between mb-1">
          <span>
            {{ faceFor(bucket.score) }}
            {{ $t(`studentSatisfaction.scores.${bucket.score}`) }}
          </span>
          <span class="grey--text">
            {{ bucket.count }} · {{ formatPct(bucket.percentage) }}
          </span>
        </div>
        <v-progress-linear
          :value="bucket.percentage"
          :color="colorFor(bucket.score)"
          height="18"
          rounded
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';

const FACES = ['😞', '🙁', '😐', '🙂', '😄'];
const COLORS = ['red', 'deep-orange', 'amber', 'light-green', 'green'];

export default {
  name: 'SatisfactionDistribution',
  components: { VueJsonToCsv },
  props: {
    scoreDistribution: { type: Array, default: () => [] },
    campaignName: { type: String, default: '' },
  },
  computed: {
    exportRows() {
      return this.scoreDistribution.map((bucket) => ({
        score: bucket.score,
        count: bucket.count,
        percentage: this.formatPct(bucket.percentage),
      }));
    },
    exportLabels() {
      return {
        score: { title: this.$t('surveys.export.col_score') },
        count: { title: this.$t('surveys.export.col_count') },
        percentage: { title: this.$t('surveys.export.col_percentage') },
      };
    },
    exportFilename() {
      return `distribucion_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  methods: {
    faceFor(score) {
      return FACES[score - 1] || '';
    },
    colorFor(score) {
      return COLORS[score - 1] || 'grey';
    },
    formatPct(value) {
      return `${Math.round(value || 0)}%`;
    },
  },
};
</script>
